import { render, staticRenderFns } from "./ChatRoot.vue?vue&type=template&id=17b23ec5&scoped=true&"
import script from "./ChatRoot.vue?vue&type=script&lang=ts&"
export * from "./ChatRoot.vue?vue&type=script&lang=ts&"
import style0 from "./ChatRoot.vue?vue&type=style&index=0&id=17b23ec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b23ec5",
  null
  
)

export default component.exports